import CustomerOrderRevision from './customer-order-revision';
import Route, { type RouteWithoutRelationships, toRouteWithoutRelationships } from './route';
import ScheduledMeal, {
  type ScheduledMealWithoutCycleMenu,
  toScheduledMealWithoutCycleMenu,
} from './scheduled-meal';
import Site, { type SiteWithoutRelationships, toSiteWithoutRelationships } from './site';

import {
  type SiteMenuBeverageOrderView,
  toSiteMenuBeverageOrderView,
} from './site-menu-beverage-order';

import { type SiteMenuSupplyOrderView, toSiteMenuSupplyOrderView } from './site-menu-supply-order';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { type ServiceType } from '../types';
import type SiteMenuBeverageOrder from './site-menu-beverage-order';
import type SiteMenuSupplyOrder from './site-menu-supply-order';
@JsonApiResource({
  type: 'site-menu-order',
})
export default class SiteMenuOrder extends BaseEntity {
  @JsonApiProperty({ type: 'string', readOnly: true }) mealName: string = '';
  @JsonApiProperty({ type: 'string', readOnly: true }) mealCategoryName: string = '';
  @JsonApiProperty({ type: 'string', readOnly: true }) routeName: string = '';
  @JsonApiProperty({ resolver: Number, readOnly: true }) unitPrice: number = 0.0;
  @JsonApiProperty({ resolver: Number, readOnly: true }) totalPrice: number = 0.0;
  @JsonApiProperty({ resolver: Number }) quantity: number = 0;
  mealType: string = '';
  diets: string[] | null = null;
  preferences: string[] | null = null;
  mainType: 'Regular' | 'Diabetic' = 'Regular';
  comment: string | undefined = undefined;
  // newMealType?: string = '';
  @JsonApiProperty({ type: 'boolean' }) prepackBeverages: boolean = true;
  serviceType: ServiceType = 'C1';
  @JsonApiRelationship('site') site = new Site();
  @JsonApiRelationship('customer-order-revision') customerOrderRevision =
    new CustomerOrderRevision();

  @JsonApiRelationship('scheduled-meal') scheduledMeal = new ScheduledMeal();
  @JsonApiRelationship('route') route = new Route();
  @JsonApiRelationship('site-menu-beverage-order')
  siteMenuBeverageOrders?: SiteMenuBeverageOrder[] = [];

  @JsonApiRelationship('site-menu-supply-order') siteMenuSupplyOrders?: SiteMenuSupplyOrder[] = [];
}
export interface SiteMenuOrderView
  extends Omit<
    SiteMenuOrder,
    | 'site'
    | 'customerOrderRevision'
    | 'scheduledMeal'
    | 'route'
    | 'siteMenuBeverageOrders'
    | 'siteMenuSupplyOrders'
  > {
  site: SiteWithoutRelationships;
  scheduledMeal: ScheduledMealWithoutCycleMenu;
  route: RouteWithoutRelationships;
  siteMenuBeverageOrders?: SiteMenuBeverageOrderView[];
  siteMenuSupplyOrders?: SiteMenuSupplyOrderView[];
}

export const toSiteMenuOrderView = (smo: SiteMenuOrder): SiteMenuOrderView => {
  return {
    id: smo?.id,
    mealName: smo?.mealName,
    mealCategoryName: smo?.mealCategoryName,
    routeName: smo?.routeName,
    unitPrice: smo?.unitPrice,
    totalPrice: smo?.totalPrice,
    quantity: smo?.quantity,
    mealType: smo?.mealType,
    diets: smo?.diets,
    preferences: smo?.preferences,
    mainType: smo?.mainType,
    comment: smo?.comment,
    prepackBeverages: smo?.prepackBeverages,
    serviceType: smo?.serviceType,
    site: toSiteWithoutRelationships(smo?.site),
    scheduledMeal: toScheduledMealWithoutCycleMenu(smo?.scheduledMeal),
    route: toRouteWithoutRelationships(smo?.route),
    siteMenuBeverageOrders:
      smo?.siteMenuBeverageOrders?.map((smbo) => toSiteMenuBeverageOrderView(smbo)) ?? [],
    siteMenuSupplyOrders:
      smo?.siteMenuSupplyOrders?.map((smso) => toSiteMenuSupplyOrderView(smso)) ?? [],
  };
};
